import script from "./ImageSide.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageSide.vue?vue&type=script&setup=true&lang=js"

import "./ImageSide.vue?vue&type=style&index=0&id=4459b21f&lang=scss"

const __exports__ = script;

export default __exports__